import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export function Landing() {
  return (
    <div className="flex flex-col gap-20 pb-20 -mt-8">
      {/* Hero Section */}
      <section className="bg-brand-dark text-white rounded-3xl p-8 md:p-16 mt-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-red rounded-full opacity-10 blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="max-w-3xl relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white leading-tight">
            Invierte con Confianza.<br/>
            <span className="text-brand-red font-accent text-5xl md:text-7xl font-normal">Al Estilo Latino.</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl">
            Descubre el valor real de las acciones con nuestro motor de puntuación avanzado. Construye tu portafolio y toma decisiones inteligentes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/register">
              <Button variant="primary" className="w-full sm:w-auto text-lg px-8 py-3">
                Comenzar Gratis
              </Button>
            </Link>
            <Link to="/login">
              <Button variant="outline" className="w-full sm:w-auto text-lg px-8 py-3 bg-transparent text-white border-gray-600 hover:bg-gray-800">
                Iniciar Sesión
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="grid md:grid-cols-3 gap-8">
        <FeatureCard 
          icon={FiIcons.FiTarget}
          title="Valor Justo & MOS"
          description="Calculamos el Margen de Seguridad (MOS) basándonos en el crecimiento histórico para encontrar acciones en oferta."
        />
        <FeatureCard 
          icon={FiIcons.FiAward}
          title="Motor de Puntuación"
          description="Algoritmo de 100 puntos evaluando ROIC, Patrimonio, EPS y Ventas para asegurar calidad corporativa."
        />
        <FeatureCard 
          icon={FiIcons.FiPieChart}
          title="Rastreador de Portafolio"
          description="Mantén registro de tus inversiones, ganancias y recibe alertas cuando tus acciones cambien de estado."
        />
      </section>

      {/* Pricing */}
      <section className="max-w-4xl mx-auto w-full">
        <h2 className="text-3xl font-bold text-center mb-12">Planes Simples y Transparentes</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <PricingCard 
            title="Básico"
            price="Gratis"
            features={[
              "Buscador de acciones básico",
              "Resumen de Semáforo (Oferta/Vigilar)",
              "Lista de seguimiento (Max 10)",
              "Rastreador de portafolio básico"
            ]}
          />
          <PricingCard 
            title="Premium"
            price="$15/mes"
            isPremium
            features={[
              "Buscador avanzado completo",
              "Detalles exactos de Valor Justo y MOS",
              "Listas de seguimiento ilimitadas",
              "Proyecciones de portafolio a 10 años",
              "Gráficos financieros detallados"
            ]}
          />
        </div>
      </section>
    </div>
  );
}

function FeatureCard({ icon, title, description }) {
  return (
    <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div className="w-12 h-12 bg-red-50 text-brand-red rounded-xl flex items-center justify-center mb-4 text-2xl">
        <SafeIcon icon={icon} />
      </div>
      <h3 className="text-xl font-bold mb-2 text-brand-dark">{title}</h3>
      <p className="text-brand-slate leading-relaxed">{description}</p>
    </div>
  );
}

function PricingCard({ title, price, features, isPremium }) {
  return (
    <div className={`p-8 rounded-2xl border ${isPremium ? 'border-brand-red shadow-lg relative' : 'border-gray-200 bg-white'}`}>
      {isPremium && (
        <div className="absolute top-0 right-1/2 translate-x-1/2 -translate-y-1/2 bg-brand-red text-white px-3 py-1 rounded-full text-sm font-bold">
          Recomendado
        </div>
      )}
      <h3 className="text-2xl font-bold text-brand-dark mb-2">{title}</h3>
      <div className="text-4xl font-bold text-brand-dark mb-6">{price}</div>
      <ul className="space-y-4 mb-8">
        {features.map((f, i) => (
          <li key={i} className="flex items-start gap-3 text-gray-600">
            <SafeIcon icon={FiIcons.FiCheckCircle} className="text-green-500 mt-1 flex-shrink-0" />
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <Link to="/register" className="block w-full">
        <Button variant={isPremium ? 'primary' : 'outline'} className="w-full py-3">
          Elegir {title}
        </Button>
      </Link>
    </div>
  );
}